import { CookieAttributes } from 'js-cookie';

import portsApi from '@/framework/ports/portsApi';

const Cookie = {
  get: (key: string): Promise<string> => portsApi.invoke('Cookie.get', [key]),
  has: (key: string): Promise<boolean> => portsApi.invoke('Cookie.has', [key]),
  remove: (key: string): Promise<boolean> =>
    portsApi.invoke('Cookie.remove', [key]),
  set: (key: string, value: any, options?: CookieAttributes): Promise<string> =>
    portsApi.invoke('Cookie.set', [key, value, options]),
};

export default Cookie;
